import { SafeString } from 'handlebars/dist/handlebars';

export function cFeatureDescription(options) {
  return new SafeString(`<p class="c-feature__description">${options.fn(this)}</p>`);
}
